// IE 2026 11 03 / ODOO-350449 (заказ Игоря: визуальный выбор размера в меню виджета): пункт «Size» меню ≡ виджета (раздел «Layout», utils/widgetCornerMenu.cornerLayoutMenu) —
// вместо подменю из 8 текстовых пунктов «Scale width N, height M» (Alt 1…Alt 8) — одна строка: подпись, сетка 4×2 кнопок-миниатюр (ряд 1 — высота 1, ряд 2 — высота 2,
// ширина 1…4 слева направо; текущий масштаб выделен) и поля W / H (% страницы) — те же, что у полей формы угла (Widget.vue applyLayoutInputs).
// Кнопка сетки исполняет ту же команду, что прежний пункт (onScale__Click с params), пункты остаются в данных меню — поиск и Alt-подсказки находят их как раньше.
// Выключатель — настройка базы / браузера fe.ux.widgetMenuSizeGrid (по умолчанию ВКЛ; false — прежние текстовые пункты). Чистые функции без Vue и стора —
// tests/unit/widgetMenuSize.test.mjs.

export const SIZE_GRID_FLAG = 'fe.ux.widgetMenuSizeGrid'
export const SIZE_GRID_COLS = 4
export const SIZE_GRID_ROWS = 2

// механизм включён: настройка не выключена явным false
export function sizeGrid_on(store) {
    try {
        if (!store || typeof store.setting !== 'function') return true
        return store.setting(SIZE_GRID_FLAG, true) !== false
    } catch (e) { return true }
}

// IE 2026 11 04 / ODOO-350449 (замечание Игоря: поля Ш/В — строкой «Ширина / висота, % сторінки» вместо мёртвого пункта): поля W / H уходят из строки «Size»
// в пункт «Width / height, % of page» раздела «Layout» (прежде он открывал у угла ряд полей и не срабатывал из меню ≡). Выключатель fe.ux.sizeRowInline
// (дефолт ВКЛ; false — как было: поля в строке «Size», пункт «Width / height, % of page…» открывает поля у угла)
export const SIZE_ROW_INLINE_FLAG = 'fe.ux.sizeRowInline'   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: поля Ш/В — строкой «Ширина / висота, % сторінки» вместо мёртвого пункта)

export function sizeRowInline_on(store) {   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: поля Ш/В — строкой «Ширина / висота, % сторінки» вместо мёртвого пункта)
    try {
        if (!store || typeof store.setting !== 'function') return true
        return store.setting(SIZE_ROW_INLINE_FLAG, true) !== false
    } catch (e) { return true }
}

// ширина / высота кнопки масштаба (в клетках сетки страницы) либо null
export function sizeCell_of(a) {
    const p = a && a.params
    const w = Number(p && p.widthMin_rem), h = Number(p && p.heightMin_rem)
    return (Number.isInteger(w) && Number.isInteger(h) && w >= 1 && h >= 1) ? { w, h } : null
}

// модель сетки: ряды по высоте (1…ROWS), в ряду клетки по ширине (1…COLS); клетка — { w, h, item } (item — пункт меню с той же командой) либо { w, h, item: null }
// (кнопки нет — пустое место держит сетку ровной). Нет ни одного пункта масштаба — null
export function sizeGrid_model(items) {
    const by = new Map()
    for (const it of items || []) { const c = sizeCell_of(it); if (c && !by.has(c.w + 'x' + c.h)) by.set(c.w + 'x' + c.h, it) }
    if (!by.size) return null
    const rows = []
    for (let h = 1; h <= SIZE_GRID_ROWS; h++) {
        const row = []
        for (let w = 1; w <= SIZE_GRID_COLS; w++) row.push({ w, h, item: by.get(w + 'x' + h) || null })
        rows.push(row)
    }
    return rows
}

// текущий масштаб виджета в клетках — та же формула, что у подсветки кнопок масштаба формы угла (Widget.vue mouseenter_btnScale): из живого layout_pct,
// без него — запасной пресет записи doc.widthMin_rem / heightMin_rem; плавающий виджет (Free) — null (масштаб к нему не относится)
export function sizeGrid_current(styleWidget, stylePage, doc) {
    const sw = styleWidget || {}
    if (sw.dock === 'popout') return null
    const sp = stylePage || {}
    const lp = sw.layout_pct || {}
    const W = Number(sp.width_rem) || 4, H = Number(sp.height_rem) || 2
    const w = lp.width != null ? Math.max(1, Math.round(lp.width / 100 * W)) : (Number(doc && doc.widthMin_rem) || 1)
    const h = lp.height != null ? Math.max(1, Math.round(lp.height / 100 * H)) : (Number(doc && doc.heightMin_rem) || 1)
    return { w, h }
}

export function sizeGrid_isCurrent(cell, cur) { return !!(cell && cur && cell.w === cur.w && cell.h === cur.h) }

// миниатюра клетки: доля закрашенной части по ширине / высоте, %
export function sizeCell_fill(cell) {
    if (!cell) return { width: '0%', height: '0%' }
    return { width: Math.round(Math.min(1, cell.w / SIZE_GRID_COLS) * 100) + '%', height: Math.round(Math.min(1, cell.h / SIZE_GRID_ROWS) * 100) + '%' }
}

// поле W / H: число процентов страницы либо null (пустое, нечисловое, ≤ 0 — не применяется); запятая — десятичный разделитель; больше 100 — 100
export function sizePct_parse(v) {
    if (v === null || v === undefined) return null
    if (typeof v === 'number') return (Number.isFinite(v) && v > 0) ? Math.min(100, v) : null
    const s = String(v).trim().replace(',', '.')
    if (!s || !/^[+]?(\d+\.?\d*|\.\d+)$/.test(s)) return null
    const n = Number(s)
    return (Number.isFinite(n) && n > 0) ? Math.min(100, n) : null
}

// значения полей W / H — та же формула, что Widget.vue fillLayoutInputs (закреплённый: layout_pct, без него — клетки / клетки страницы; плавающий — размер окна)
export function sizePct_current(styleWidget, stylePage, sizeFn) {
    const sw = styleWidget || {}
    const r2 = (v) => Math.round(v * 100) / 100
    if (sw.dock === 'popout') {
        const size = (typeof sizeFn === 'function' ? sizeFn() : null) || {}
        return { width: r2((size.width_pct || 0) * 100), height: r2((size.height_pct || 0) * 100) }
    }
    const sp = stylePage || {}
    const lp = sw.layout_pct || {}
    const W = Number(sp.width_rem) || 4, H = Number(sp.height_rem) || 2
    return { width: r2(lp.width ?? (sw.width_rem || 1) / W * 100), height: r2(lp.height ?? (sw.height_rem || 1) / H * 100) }
}

export const stats = { cellClicks: 0, pctApplied: 0, pctRejected: 0 }
if (typeof window !== 'undefined') window.__menuSizeGrid = stats   // счётчики для проб

// IE 2026 11 03 / ODOO-350449 (webscm #128539: меню закрывалось при вводе в поиск после W = 100): панель-меню (MenuPanel.place) ставится от прямоугольника кнопки-якоря.
// Узкий виджет у левого края, W = 100 — виджет растёт, ≡ уезжает к правому краю; следующий place() (наблюдатель q — ввод в поиск) переносил панель под новое место кнопки,
// панель уходила из-под курсора → pointerleave → _leaveCheck → hide. Теперь прямоугольник якоря запоминается при первом place() после открытия и держится, пока панель открыта
// (экран в пределах — по-прежнему clamp в place). Выключатель fe.ux.menuSearchKeepOpen (дефолт ВКЛ; false — якорь живой, как было)
export const MENU_KEEP_OPEN_FLAG = 'fe.ux.menuSearchKeepOpen'

export function menuKeepOpen_on(store) {
    try {
        if (!store || typeof store.setting !== 'function') return true
        return store.setting(MENU_KEEP_OPEN_FLAG, true) !== false
    } catch (e) { return true }
}

// saved — запомненный прямоугольник (или null), live — живой прямоугольник якоря, on — выключатель → { rect: от чего ставить панель, saved: что запомнить }
export function menuAnchor_rect(saved, live, on) {
    if (!on || !live) return { rect: live, saved: null }
    if (saved) return { rect: saved, saved }
    const r = { left: +live.left || 0, right: +live.right || 0, top: +live.top || 0, bottom: +live.bottom || 0, width: +live.width || 0, height: +live.height || 0 }
    return { rect: r, saved: r }
}
